import React, { useEffect, useState } from "react";
import Allergy from "./Allergy";
import SocialHistory from "./SocialHistory";
import PastMedicalHistory from "./PastMedicalHistory";
import SurgicalHistory from "./SurgicalHistory";
import FamilyHistory from "./FamilyHistory";
import Medication from "./Medication";
import ChronicCondition from "./ChronicCondition";
import Layout from "../../../Layout";
import Vaccination from "./Vaccination";
import { Select } from "antd";
import PatientService from "../../../Services/PatientService";
import { MdFamilyRestroom } from "react-icons/md";
import EmergencyData from "./EmergencyData";

const MedicaHistory = () => {
  const patJson = localStorage.getItem("patientData");
  const patObj = patJson ? JSON.parse(patJson) : null;
  const [famList, setFamList] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(patObj);

  useEffect(() => {
    getFamilyList();
  }, []);

  const getFamilyList = async () => {
    const payload = {
      parentPatientId: patObj?.patientId,
    };

    try {
      const response = await PatientService.getPatient(payload);
      setFamList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handlePatientChange = (value) => {
    if (value === patObj.patientId) {
      setSelectedPatient(patObj);
    } else {
      const selectedPatObj = famList.find((pat) => pat.patientId === value);
      setSelectedPatient(selectedPatObj);
    }
  };

  return (
    <Layout>
      <div className="p-5 mx-5">
        <div className="flex sm:flex-col justify-between m-3">
          <h2 className="text-lg font-bold mb-4">Medical History</h2>
          {!patObj?.parentPatientId && (
            <div className="flex items-center gap-2">
              <MdFamilyRestroom className="text-iconBlue" />
              <Select
                className="w-36 h-9"
                value={selectedPatient.patientId}
                onChange={handlePatientChange}
              >
                <Select.Option value={patObj?.patientId}>
                  {patObj.firstName}
                </Select.Option>
                {famList.length !== 0 &&
                  famList.map((fam) => (
                    <Select.Option value={fam.patientId}>
                      {fam.firstName}
                    </Select.Option>
                  ))}
              </Select>
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-1 xl:grid-cols-4 gap-5">
          <Allergy selectedPatient={selectedPatient} />
          <PastMedicalHistory selectedPatient={selectedPatient} />
          <SurgicalHistory selectedPatient={selectedPatient} />
          <FamilyHistory selectedPatient={selectedPatient} />
          <SocialHistory selectedPatient={selectedPatient} />
          <Medication selectedPatient={selectedPatient} />
          <ChronicCondition selectedPatient={selectedPatient} />
          <Vaccination selectedPatient={selectedPatient} />
          <EmergencyData selectedPatient={selectedPatient} />
        </div>
      </div>
    </Layout>
  );
};

export default MedicaHistory;
